var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_2905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.57238 1.80469H2.25587C1.75752 1.80469 1.35352 2.20869 1.35352 2.70705V9.02355C1.35352 9.52191 1.75752 9.92591 2.25587 9.92591H8.57238C9.07074 9.92591 9.47474 9.52191 9.47474 9.02355V2.70705C9.47474 2.20869 9.07074 1.80469 8.57238 1.80469Z",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21887 0.902344V2.70706",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 0.902344V2.70706",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35352 4.51172H9.47474",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_2905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8283,
    height: 10.8283,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f676170af2198fd53d0d2ac574b9982b.svg";
export { ForwardRef as ReactComponent };